import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";
export type Categories = {
    id: string;
    duration: string | null;
    title:string | null;
    name:string;
    category:string;
    certificateExamId:string;
    questionCount:number
}[];

    type getCategoriesResponse = {
        statusCode?: number;
        error?: null | ApiError;
        data?: Categories;
      
    }
    export const GetCategoriesByCertificateId = async (CertificateId: string): Promise<getCategoriesResponse> => {
        try {
            const response = await axios.get(`/certificate-exam/${CertificateId}/categories`);
                    return { data: response.data.categories };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error: any) {
            console.error("API Error:", error);
            if (error.response) {
                const apiError: ApiError = {
                    statusCode: error.response.status,
                    message: error.response.data.message,
                    error: error.response.data.error,
                };
                return { error: apiError };
            } else {
                const fallbackError: ApiError = {
                    statusCode: 500,
                    message: "An unexpected error occurred",
                };
                return { error: fallbackError };
            }
        }
    };
